// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".infoTxt {\n  text-align: center;\n  margin-top: 3em;\n  padding: 20px 0;\n}", "",{"version":3,"sources":["webpack://components/InfoText/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".infoTxt {\n  text-align: center;\n  margin-top: 3em;\n  padding: 20px 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
